import React, { useState, useEffect } from 'react';
import db from '../../assets/db/main-db.json';

const InventoryForm = ({ onFormDataChange }) => {
    const [formData, setFormData] = useState({
        brand: '',
        model: '',
        variant: '',
        condition: '',
        purchasePrice: '',
        sellingPrice: '',
        imei_1: '',
        imei_2: '',
        notes: '',
    });

    const allBrands = db.brands;
    const [allModels, setAllModels] = useState([]);
    const [allVariants, setAllVariants] = useState([]);
    const allConditions = ['Silver', 'Gold', 'Platinum'];

    // Handle changes in the form fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        onFormDataChange({ ...formData, [name]: value }); // Propagate change to parent
    };

    const handleModelChange = (e) => {
        const selectedBrand = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            brand: selectedBrand,
            model: '',
            variant: '',
        }));
        // Load models based on the selected brand
        const models = allBrands.find(brand => brand.name === selectedBrand)?.models || [];
        setAllModels(models);
        setAllVariants([]); // Clear variants when the brand changes
        onFormDataChange({ ...formData, brand: selectedBrand, model: '', variant: '' }); // Propagate change to parent
    };

    const handleVariantChange = (e) => {
        const selectedModel = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            model: selectedModel,
            variant: '',
        }));
        // Load variants based on the selected model
        const variants = allModels.find(model => model.name === selectedModel)?.variants || [];
        setAllVariants(variants);
        onFormDataChange({ ...formData, model: selectedModel, variant: '' }); // Propagate change to parent
    };

    return (
        <div className="form-group">
            <div style={{ display: "block", width: "100%" }}>
                <div className="select-side">
                    <select name="brand" onChange={handleModelChange} required>
                        <option value="">Select Brand</option>
                        {allBrands.map((brand) => (
                            <option key={brand.name} value={brand.name}>
                                {brand.name}
                            </option>
                        ))}
                    </select>
                    <select
                        name="model"
                        value={formData.model}
                        onChange={handleVariantChange}
                        required
                        disabled={!formData.brand}
                    >
                        <option value="">Select Model</option>
                        {allModels.map((model) => (
                            <option key={model.id} value={model.name}>
                                {model.name}
                            </option>
                        ))}
                    </select>

                    <select
                        name="variant"
                        value={formData.variant}
                        onChange={handleChange}
                        required
                        disabled={!formData.model}
                    >
                        <option value="">Select Variant</option>
                        {allVariants.map((variant) => (
                            <option key={variant.variant} value={variant.variant}>
                                {variant.variant}
                            </option>
                        ))}
                    </select>

                    <select
                        name="condition"
                        value={formData.condition}
                        required
                        onChange={handleChange}
                    >
                        <option value="">Select Condition</option>
                        {allConditions.map((condition, index) => (
                            <option key={index} value={condition}>
                                {condition}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="img-side">
                    {formData.selectedImage && <img src={formData.selectedImage} alt="Preview" />}
                </div>
            </div>

            <input
                type="number"
                name="purchasePrice"
                placeholder="Purchase Price"
                value={formData.purchasePrice}
                onChange={handleChange}
            />
            <input
                type="number"
                name="sellingPrice"
                placeholder="Selling Price"
                value={formData.sellingPrice}
                onChange={handleChange}
            />
            <input
                type="number"
                name="imei_1"
                placeholder="IMEI No.1"
                value={formData.imei_1}
                onChange={handleChange}
            />
            <input
                type="number"
                name="imei_2"
                placeholder="IMEI No.2"
                value={formData.imei_2}
                onChange={handleChange}
            />
            <input
                type="text"
                name="notes"
                placeholder="Additional Note"
                value={formData.notes}
                onChange={handleChange}
            />
        </div>
    );
};

export default InventoryForm;
